import React, { useState } from "react";
import { adminApi } from "../../../../../../services";
import { useNavigate } from "react-router-dom";
import UserSearchCard from "../../../../../../components/common/UserSearchCard";

export default function CreateFD() {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [form, setForm] = useState({
    principalAmount: "",
    interestRate: "",
    tenureMonths: "",
    startDate: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!user) {
      return alert("Please search user first");
    }
  
    try {
      const res = await adminApi.createFD({
        userId: user._id,
        ...form,
      });
  
      const createdFD = res?.data?.data;
  
      alert("FD created successfully");
  
      // ✅ PRINT FLOW
      if (window.confirm("Do you want to print the FD receipt?")) {
        navigate("/admin-dashboard/print", {
          state: {
            type: "fd",
            data: createdFD,
            returnTo: "/admin-dashboard/fds"
          },
        });
      } else {
        navigate("/admin-dashboard/fds");
      }
  
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to create FD");
    }
  };

  return (
    <div className="container">
      <h2>Create FD</h2>

      <UserSearchCard
        getUser={adminApi.getUserByAccountNumber}
        onUserFound={setUser}
      />

      {user && (
        <form onSubmit={handleSubmit} className="mt-3">
          <input className="form-control mb-2" placeholder="Amount"
            onChange={(e)=>setForm({...form, principalAmount:e.target.value})} />

          <input className="form-control mb-2" placeholder="Interest %"
            onChange={(e)=>setForm({...form, interestRate:e.target.value})} />

          <input className="form-control mb-2" placeholder="Tenure (Months)"
            onChange={(e)=>setForm({...form, tenureMonths:e.target.value})} />

          <input type="date" className="form-control mb-2"
            onChange={(e)=>setForm({...form, startDate:e.target.value})} />

          <button className="btn btn-primary w-100">Create FD</button>
        </form>
      )}
    </div>
  );
}
